/* eslint-disable react/jsx-indent-props */
import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { useStores } from "../use.store";
import { informationID, s3Url } from "../utils/constants";

const OperatingHoursComponent = observer(() => {
  const { generalStore } = useStores();
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    const filter = generalStore.information.filter(
      (item) => item.categoryId === informationID.operatingHour
    );
    // filter.map(
    //   (data) =>
    //     (data.description = JSON.parse(
    //       filter[0].description.replace(/,\s*(\}|\])/g, "$1") // sanitize
    //     ))
    // );
    setFilteredData(filter);
  }, []);

  return (
    <div className="w-full">
      <div className="flex flex-col items-center">
        {filteredData &&
        filteredData.length > 0 &&
        filteredData[0] &&
        filteredData[0].files ? (
          filteredData[0].files.map((data, index) => {
            return (
              <img
                src={`${s3Url}/information/${data.logo}`}
                alt="operating-hours"
                className="w-[70%]"
              />
            );
          })
        ) : (
          <div>No schedule available</div>
        )}
      </div>
      {/* <div className="flex flex-col gap-2 bg-white p-4 md:p-6 md:gap-6 rounded-tl-md rounded-tr-md items-center">
        {filteredData &&
        filteredData.length > 0 &&
        filteredData[0] &&
        filteredData[0].description ? (
          filteredData[0].description.map((data, index) => {
            return (
              <div
                key={index}
                className="flex flex-row justify-between w-full items-center"
              >
                <p className="text-sm md:text-2xl text-black font-normal">
                  {data.title}
                  {data.important && <span className="text-red-500">*</span>}:
                  {data.subtitle.length > 0 && <br />}
                  {data.subtitle.length > 0 && (
                    <span className="text-xs">
                      (only Court 4A and Bail Centre)
                    </span>
                  )}
                </p>
                <span className="text-sm md:text-2xl text-black ">
                  {data.value}
                </span>
              </div>
            );
          })
        ) : (
          <div>No schedule available</div>
        )}
      </div>

      <div className="flex flex-col gap-2 bg-[#F3F3F3] rounded-bl-md rounded-br-md py-3 items-center w-full">
        <span className="text-xs text-[#777777]">
          *Closed for lunch between 1.00PM and 2.00PM
        </span>
      </div> */}
    </div>
  );
});

export default OperatingHoursComponent;
